<template>
  <div v-if="fileName">
    <iframe style="height:100%" width=100% :src="`${getFilePath}`" ></iframe>
  </div>
</template>

<script>
export default {
  name: 'PDFJSViewer',
  props: {
    fileName: String,
  },
  computed: {
    getFilePath() {
      return '/static/lib/web/viewer.html?file=' + this.fileName;
    },
  },
};
</script>
<style scoped>
div {
  width: 100%;
  height: 75vh;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/previsualiserOpportunite/PDFJSViewer.vue